<template>
  <div>
    <h4 class="">比重总和：{{ valueTotal }}/{{ dataList.questionDetails.issue.total_value }}</h4>
    <div class="matrix-scale" v-for="(rowItem, id) of dataList.questionDetails.issue.items" :key="id">
      <span v-html="transformHtml(rowItem.content.text)"></span>
      <div class="slider-style">
        <el-slider
          show-input
          v-model.number="dataList.items[id].value"
          @input="handleChange($event, dataList, id)"
          input-siz="mini"
        ></el-slider>
      </div>
    </div>
  </div>
</template>

<script>
import '../public/style.css'
import { saveArr } from '../public/index.js'

export default {
  name: 'MatrixGravity',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  created() {
    this.rowData.items.forEach(element => {
      element.value = Number(element.value)
    })
    this.dataList = Object.assign({}, this.rowData)
  },
  inject: ['transformHtml'],
  computed: {
    valueTotal() {
      let total = 0
      this.dataList.items.forEach(element => {
        total += parseInt(element.value)
      })
      return total
    }
  },
  methods: {
    // 比重题 矩阵滑动题 改变值
    handleChange(val, row, id) {
      let othersTotal = 0
      this.dataList.items.forEach((ele, index) => {
        index != id && (othersTotal += parseInt(ele.value))
      })
      if (
        this.valueTotal > this.dataList.questionDetails.issue.total_value ||
        this.valueTotal == this.dataList.questionDetails.issue.total_value
      ) {
        this.dataList.items[id].value = this.dataList.questionDetails.issue.total_value - othersTotal
      }
      // if (this.updateArr.find((it, index) => it.questonId === row.questionId)) {
      //   this.updateArr.splice(index, 1)
      //   this.updateArr.push(row);
      // } else {
      //   this.updateArr.push(row);
      // }
      let ids = this.saveArr(this.dataList)
      if (ids !== -1) {
        this.updateArr.splice(ids, 1)
        this.updateArr.push(row)
      }
    },
    saveArr
  }
}
</script>

<style lang="scss" scoped>
.slider-style {
  width: 100%;
  // height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  span {
    max-width: 15%;
    text-align: center;
    padding: 0 5px;
    font-size: 14px;
    color: #606266;
  }
}
::v-deep.el-slider {
  // width: 80%;
  flex: 1;
}
.matrix-scroll > span {
  font-size: 14px;
  margin-right: 10px;
}
::v-deep.el-input__inner {
  width: 100px;
  // margin: 0;
}
::v-deep.el-input-number__decrease {
  width: 20px;
}
::v-deep.el-input-number__increase {
  left: 78px;
  width: 20px;
}
</style>
